import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { RootState } from "../../../store";
import { IDType } from "../../../config/types";
import { performAction } from "../../../store/actions/all";
import { fetchCategories } from "../../../store/actions/leagueActions";
import { AreaOfInterest } from "../../../client/api";
import { changeAoi } from "../../../store/actions/userActions";
import { fetchAois } from "../../../store/actions/aoiActions";
import { selectUserValue } from "../../../selectors";

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  getCategories: () => {
    performAction({ f: fetchCategories, p: [dispatch] });
  },
  changeAoi: (aoi: AreaOfInterest) => {
    changeAoi(dispatch, aoi);
  },
  getAois: () => {
    fetchAois(dispatch);
  }
});
const props = (state: RootState, prevProps: { leagueId?: IDType, isBottom?: boolean }) => ({
  leagues: state.leagues.value,
  ...prevProps,
  user: selectUserValue(state),
  categories: state.leagues.categories,
  aois: state.aois.value,
  aoisStatus: state.aois.status,
  favLeagueIds: state.user.favorites
    .filter((f) => f.type === "league")
    .map((f) => f.id)
});

export const connector = connect(props, mapper);
